/* istanbul ignore file
NOTE: Hooks are being properly tested, but the coverage isn't registering the tests
for the nullish operators
*/
import { useAccount } from 'reservations/account/providers/AccountProvider';
import { getEnvironmentVariables } from 'utility/environment';

const CLOVER = 'clover';

const usePayments = () => useAccount()?.payment_provider_information;

export const usePaymentProvider = () => usePayments()?.payment_provider ?? '';

export const useCloverPayments = () => ({
  cloverPaymentFormUrl: getEnvironmentVariables().CLOVER_PAYMENT_FORM_URL ?? '',
  cloverPlatformPublicKey:
    getEnvironmentVariables()?.CLOVER_PLATFORM_PUBLIC_KEY ?? ''
});

export const useHasClover = () => {
  const paymentProvider = usePaymentProvider();
  return paymentProvider === CLOVER;
};
